import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    Divider
} from "@mui/material";

import BrokerList from "./BrokerList";
import AddBrokerForm from "./AddBrokerForm";

const BrokerManagement = () => {
    const [refresh, setRefresh] = useState(false);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [openAddDialog, setOpenAddDialog] = useState(false);

    const handleOpenAdd = () => setOpenAddDialog(true);
    const handleCloseAdd = () => {
        setOpenAddDialog(false);
        setSelectedBroker(null);
    };

    const handleSuccess = () => {
        setRefresh(prev => !prev);
        handleCloseAdd();
    };

    const handleEdit = (broker) => {
        setSelectedBroker(broker);
        setOpenAddDialog(true);
    };

    return (
        <Box p={3} maxWidth={1200} mx="auto">
            <Typography variant="h5" gutterBottom>
                Broker Management
            </Typography>

            <Box display="flex" justifyContent="flex-start" mb={2}>
                <Button variant="contained" onClick={handleOpenAdd}>
                    ADD BROKER
                </Button>
            </Box>

            <BrokerList refreshTrigger={refresh} onEdit={handleEdit} />

            {/* Add Broker Dialog */}
            <Dialog open={openAddDialog} onClose={handleCloseAdd} maxWidth="md" fullWidth>
                <DialogTitle>Add Broker</DialogTitle>
                <DialogContent>
                    <AddBrokerForm
                        initialData={selectedBroker}
                        onSuccess={() => {
                            setRefresh((prev) => !prev);
                            setSelectedBroker(null);
                            setOpenAddDialog(false);
                        }}
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default BrokerManagement;
